import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

/**
 * Support/Training preview (Task Group 10, FR-6.2)
 *
 * Route: /maintenance/preview — no MembershipTierGuard here (this IS the
 * Core-reachable landing spot the guard on the four Pro-only Maintenance
 * children redirects to; guarding it too would be a redirect loop).
 *
 * Covers Support Tickets, Service Appointments, Scheduled Maintenance, and
 * Training/Drone Videos in one shared page rather than four near-identical
 * ones — all four are gated to the same `/maintenance/preview` target
 * (app-routing.module.ts), so a Core org sees the same explanation
 * regardless of which one they tried to reach.
 *
 * The Resources section (UPass/FieldWatch external links) and the
 * Maintenance Overview dashboard stay Core-visible and are NOT touched by
 * this page — FR-6.2 and tasks.md 10.3 are explicit that those are
 * unaffected.
 *
 * Reference: agent-os/specs/2026-06-29-core-pro-membership/spec.md FR-6
 */
@Component({
  selector: 'app-maintenance-preview',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="mb-4">
      <h1 class="h2 mb-1 fw-bold">Maintenance & Support</h1>
      <p class="text-muted mb-0">Get help, request service, and track your maintenance activities</p>
    </div>

    <div class="card mb-4">
      <div class="card-body p-4 p-md-5 text-center">
        <div
          class="rounded-circle bg-primary-subtle d-inline-flex align-items-center justify-content-center mb-3 size-56px"
        >
          <i class="bi bi-lock-fill text-primary fs-4" role="img" aria-label="Pro feature"></i>
        </div>
        <h4 class="fw-bold mb-2">This is a Pro feature</h4>
        <p class="text-muted mb-4 mx-auto mw-560px">
          Support Tickets, Service Appointments, Scheduled Maintenance, and Training/Drone Videos are
          available to Pro organizations, org-wide with no seat limits.
        </p>
        <a routerLink="/billing/upgrade" class="btn btn-primary px-4">Upgrade to Pro</a>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-4">
        <h6 class="fw-bold mb-2">Still need help right now?</h6>
        <p class="text-muted mb-3 small">
          Your org's Resources links (Insurance, UPass, FieldWatch) are always available from the
          sidebar, and the Maintenance overview page — including our support phone line and
          hours — stays open to every org.
        </p>
        <a routerLink="/maintenance" class="btn btn-sm btn-outline-primary">
          Back to Maintenance Overview <i class="bi bi-arrow-right ms-1"></i>
        </a>
      </div>
    </div>
  `,
})
export class MaintenancePreviewComponent {}
